import MainLayout from "@/components/layout/MainLayout";
import HeroSection from "./components/HeroSection";
import StorySection from "./components/StorySection";
import CoreValuesSection from "./components/CoreValuesSection";
import ProcessSection from "./components/ProcessSection";
import SpaceSection from "./components/SpaceSection";
import CtaSection from "./components/CtaSection";

export default function About() {
  return (
    <MainLayout>
      <HeroSection />
      <StorySection />
      <CoreValuesSection />
      <ProcessSection />
      <SpaceSection />
      <CtaSection />
    </MainLayout>
  );
}